import {HttpHelper} from "../utils/httpHelper";
import {AppConfig} from "../../appConfig";

export const LAYERS_TYPES = {
    GEOJSON: 'geojson',
    GEOJSON_NO_POI: 'geojson_no_poi',
    PROTOBUF: 'geonode_mvt',
    WMS_TEGOLA: 'wms_tegola'
    // FIXME faltan tipos
};

export class LayersService {

    static async fetchLayers() {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/layers`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchLayerData(layerId) {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/layers/${layerId}/data`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchLayerAttributes(layerId) {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/layers/${layerId}/attributes`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchLayerByCode(layerCode) {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/layer-by-code/${layerCode}`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchGroups() {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/viewer-groups`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchMaps() {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/maps`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchScenarios() {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/maps/scenarios`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchDefaultLayersOfMap(mapId) {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/maps/${mapId}/default-layers`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchGroupsWithLayers() {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/viewer-groups-with-layers`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchGroupsWithLayersOfMapId(mapId) {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/maps/${mapId}/viewer-groups-with-layers`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchElementsWithCriteria(query, langKey) {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/elements-serach?query=${query}&lang=${langKey}`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchMapData(mapId) {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/maps/${mapId}`);
        } catch (e) {
            console.log(e);
        }
    }

    static async fetchMapDataByCode(code) {
        try {
            return await HttpHelper.get(`${AppConfig.APP_URL}/api/maps-by-code/${code}`);
        } catch (e) {
            console.log(e);
        }
    }
}